export const globalSizes = {
  none: '0rem',
  smallest: 'var(--s-5)',
  tiny: 'var(--s-4)',
  xxs: 'var(--s-3)',
  xs: 'var(--s-2)',
  small: 'var(--s-1)',
  base: 'var(--s0)',
  medium: 'var(--s1)',
  large: 'var(--s2)',
  xl: 'var(--s3)',
  xxl: 'var(--s4)',
  largest: 'var(--s5)',
  measure: 'var(--measure)',
};
